import React, { useEffect } from "react";
import Banner from "../components/home/Banner";
import StatsBlock from "../components/home/StatsBlock";
import GlobalMarkets from "../components/home/GlobalMarkets";
import ProofOfEdge from "../components/home/ProofOfEdge";
import Speed from "../components/home/Speed";
import Accounts from "../components/home/Accounts";
import MoreControl from "../components/home/MoreControl";
import Security from "../components/home/Security";
import MissionVision from "../components/home/MissionVision";
import CTASection from "../components/home/CTASection";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <GlobalMarkets />
      <StatsBlock />
      <ProofOfEdge />
      <Speed />
      <Accounts />
      <MoreControl />
      <Security />
      <MissionVision />
      <CTASection />
    </div>
  );
}

export default Home;
